<template>


  <div>
    <div class="box box-default">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t('pages.reports.exerciseReports')}}</h3>
      </div>
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ $t('pages.reports.reported')}} </th>
              <th>{{ $t('pages.reports.user')}} </th>
              <th>{{ $t('pages.reports.status')}}</th>
              <th>{{ $t('pages.reports.comment')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="report in reports">
              <th scope="row">{{ report.id }}</th>
              <td>{{ getDate(report.createdAt) }}</td>
              <td v-if="report.user"> {{report.user.firstName}} {{report.user.lastName}} </td>
              <td>
                <a @click.prevent="openModal(report.exerciseId)">{{ report.description }}</a>
              </td>
              <td>
                <button v-if="report.status == 'resolved'" type="button" class="btn btn-success" @click.prevent="changeStatus(report.id,report.status)">{{ $t('pages.reports.compareResolved') }}</button>
                <button v-else-if="report.status == 'pending'" type="button" class="btn btn-default" @click.prevent="changeStatus(report.id,report.status)">{{ $t('pages.reports.comparePending') }}</button>
                <button v-else-if="report.status == 'ignored'" type="button" class="btn btn-danger" @click.prevent="changeStatus(report.id,report.status)">{{ $t('pages.reports.compareIgnored') }}</button>
              </td>
              <td>
                <!-- <button type="button" class="btn btn-default" @click.prevent="editExercise(report.exerciseId)">
                  <i class="fa fa-edit"></i>
                  {{ $t('pages.reports.edit')}} {{ report.exerciseId }}
                </button> -->
                <button type="button" class="btn btn-danger" @click.prevent="deleteReport(report.id)">
                  <i class="fa fa-trash"></i>
                </button>

              </td>
            </tr>
          </tbody>
        </table>
        <!-- /.box-body -->
      </div>
    </div>
    <div class="modal modal-default fade" id="modal-show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.preview')}} [ {{CelotnaNaloga.id}} ] </h4>
          </div>
          <div class="modal-body">

                <exercise :bareBonesExercise="CelotnaNaloga"></exercise>
           
          </div>
          <div class="modal-footer">
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- -->
    <div class="modal modal-default fade" id="modal-edit">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.editexercise.prompt')}}</h4>
          </div>
          <div class="modal-body">
                <editexercise></editexercise>
          </div>
          <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click.prevent="submitEdit()">{{ this.$t('pages.profile.update')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>

</template>

<script>
  // import Vue from 'vue'
  import Rest from './../../services/rest'
  import editexercise from './../admin/EditExercise'
  // import router from './../../router/router'
  import Exercise from '@/components/exercises/Exercise.vue'
  import { mapState } from 'vuex'
  const moment = require('moment')
  export default {
    data () {
      return {
        reports: [],
        reportVal: ['pending', 'ignored', 'resolved']
      }
    },
    components: {
      editexercise,
      'exercise': Exercise
    },
    computed: {
      ...mapState({
        CelotnaNaloga: state => state.exerciseForModal,
        exerciseId: state => state.exercises.submitExercise.id
      })
    },
    methods: {
      editExercise (eId) {
        // router.push(this.$route.path + '/' + eId)
        // router.push({name: 'editexercise', params: {nid: eId.toString()}})
        this.openModalEdit(eId)
      },
      getReports: function () {
        var tren = this
        return Rest.request('GET', '/exerciseReports').then(function (data) {
          tren.reports = data
        }).catch(function (err) {
          tren.reports = err
          console.log(err)
        })
      },
      getExerciseById (exerId) {
        return Rest.request('GET', '/exercises/' + exerId).then(function (data) {
          return data
        }).catch(function (err) {
          return err
        })
      },
      preusmeri (exerId) {

      },
      changeStatus (reportId, trenStatus) {
        var tren = this
        var postdata = {
          id: reportId,
          status: tren.reportVal[(tren.reportVal.indexOf(trenStatus) + 1) % tren.reportVal.length]
        }
        return Rest.request('PUT', '/exerciseReports/' + reportId, postdata).then(function (data) {
          tren.getReports()
        }).catch(function (err) {
          console.log(err)
        })
      },
      deleteReport (rId) {
        var answer = confirm('Are you sure?')
        if (answer) {
          var tren = this
          var postdata = {
            id: rId
          }
          return Rest.request('DELETE', '/exerciseReports/' + rId, postdata).then(function (data) {
            tren.getReports()
          }).catch(function (err) {
            console.log(err)
          })
        } else {
            // some code
        }
      },
      getDate (exe) {
        return moment(exe.createdAt).format('MM/DD/YYYY HH:mm')
      },
      openModal (id) { // show modal
        this.$store.dispatch('updateModalForExercise', id).then(() => {
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
          })
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          window.jQuery('#modal-show').modal('toggle')
        })
      },
      openModalEdit (id) { // edit modal
        this.$store.dispatch('updateModalForExercise', id).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'id', value: id})
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          window.jQuery('#modal-edit').modal('toggle')
        })
      },
      submitEdit () {
        this.$store.dispatch('submitEditedExercise', {
          exerciseId: this.exerciseId,
          data: JSON.stringify(this.CelotnaNaloga)
        })
        window.jQuery('#modal-edit').modal('hide')
      }
    },
    created () {
      this.getReports()
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Reports.vue?f5772044